import gql from "graphql-tag";


export const RefreshAccessTokenDocument = gql`
    mutation RefreshAccessToken($input: RefreshAccessTokenInput!) {
        refreshAccessToken(input: $input) @rest(type: "AccessToken", path: "token/refresh", method: "POST") {
            access_token
            expires_in
            endpoints
        }
    }
`;
export type RefreshAccessTokenResult = {
    refreshAccessToken: {
        access_token: string
        expires_in: number
    }
}
export type RefreshAccessTokenVars = {
    input: object
}


export const CreateAccessTokenDocument = gql`
    mutation CreateAccessToken($input: CreateAccessTokenInput!) {
        createAccessToken(input: $input) @rest(type: "AccessToken", path: "token?{args.input}", method: "POST") {
            access_token
            expires_in
            endpoints
        }
    }
`;
export type CreateAccessTokenResult = {
    createAccessToken: {
        access_token: string
        expires_in: number
    }
}
export type CreateAccessTokenVars = {
    input: {
        username: string
        password: string
    }
}


export const DeleteAccessTokenDocument = gql`
    mutation DeleteAccessToken($input: DeleteAccessTokenInput!) {
        deleteAccessToken(input: $input) @rest(path: "token", type: "DeleteAccessToken", method: "DELETE") {
            NoResponse
        }
    }
`;
export type DeleteAccessTokenResult = {
    deleteAccessToken: boolean
}
export type DeleteAccessTokenVars = {
    input: object
};


export const GetAboutMeFromAVDocument = gql`
    query GetAboutMeAV {
        aboutMeAV @rest(type: "AboutMeAV", path: "remote/av/api/v2/about-me/", method: "GET") {
            aboutMe {
                userName
                companyName
                email
                inn
                kpp
                phone
            }
        }
    }
`;
export type GetAboutMeFromAVVars = {}
export type GetAboutMeFromAVResult = {
    aboutMeAV: {
        aboutMe: {
            phone: string
            userName: string
            companyName: string
            email: string
            kpp: string
            inn: string
        }
    },
}


export const GetAboutMeFromERPDocument = gql`
    query GetAboutMeERP {
        aboutMeERP @rest(type: "AboutMeERP", path: "remote/erp/api/v2/about-me/", method: "GET") {
            aboutMe {
                userName
                companyName
                email
                inn
                kpp
                phone
            }
        }
    }
`;
export type GetAboutMeFromERPVars = {}
export type GetAboutMeFromERPResult = {
    aboutMeERP: {
        aboutMe: {
            phone: string
            userName: string
            companyName: string
            email: string
            kpp: string
            inn: string
        }
    },
}


export const PingERPEndpointDocument = gql`
    query PingERP {
        aboutMeERP @rest(type: "AboutMeERP", path: "remote/erp/api/v2/about-me/", method: "GET") {
            aboutMe {
                userName
                companyName
                email
                inn
                kpp
                phone
            }
        }
    }
`;
export type PingERPEndpointVars = {}
export type PingERPEndpointResult = {};


export const PingAVEndpointDocument = gql`
    query PingAV {
        aboutMeAV @rest(type: "AboutMeAV", path: "remote/av/api/v2/about-me/", method: "GET") {
            aboutMe {
                userName
                companyName
                email
                inn
                kpp
                phone
            }
        }
    }
`
export type PingAVEndpointVars = {}
export type PingAVEndpointResult = {};
